/** Waiting on you's standard look (signed-in-home.html Band 4 .b4Rows): a ruled row per thing, its action on the right. */
import { useId } from 'react';

import { APPROVED_PAYMENT } from '@/utils/waitingBooking';

import { partsOf, pieceRoot } from '../../contract/runtime';
import account from '../../styles/account.module.css';
import { Icon } from '../../ui/Icon';
import { onLink } from '../../ui/onLink';
import css from './WaitingOnYou.module.css';
import type { WaitingOnYouRuntime } from './useWaitingOnYou';
import { contract } from './contract';

const part = partsOf(contract);

export function WaitingOnYouView({ state, actions }: WaitingOnYouRuntime) {
  const headingId = useId();
  if (state.empty) return null;
  return (
    <section className={`${account.sec} ${css.section}`} aria-labelledby={headingId} {...pieceRoot(contract)} {...part('section')}>
      <div className={`${account.label} ${css.head}`} {...part('head')}>
        <div className={`${account.eyebrow} ${css.heading}`} id={headingId} {...part('heading')}>
          Waiting on you
        </div>
      </div>
      <ul className={css.rows}>
        {state.held.map((h) => (
          <li key={h.href} {...part('row')}>
            <a className={css.row} href={h.href} onClick={onLink(() => actions.open(h.href))} {...part('held')}>
              <Icon name="clock" className={css.ic} part={part('icon')} />
              <span className={css.txt}>
                <b>{h.name}</b>, {h.date}. Finish by {h.finishBy} to keep it.
              </span>
              <span className={account.act}>{h.action}</span>
            </a>
          </li>
        ))}
        {state.summary && (
          <li className={css.row} {...part('formsSummary')}>
            <Icon name="form" className={css.ic} part={part('icon')} />
            <span className={css.txt}>
              <b>{state.summary.count} forms to fill out</b>, {state.summary.oldestSent}
            </span>
            {state.formsOpen ? (
              <button type="button" className={account.act} onClick={actions.closeForms} aria-expanded="true" {...part('showLess')}>
                Show less
              </button>
            ) : (
              <button type="button" className={account.act} onClick={actions.openForms} aria-expanded="false" {...part('viewForms')}>
                View forms
              </button>
            )}
          </li>
        )}
        {state.forms.map((f) => (
          <li key={f.href} className={state.summary ? css.nested : undefined} {...part('row')}>
            <a className={css.row} href={f.href} onClick={onLink(() => actions.open(f.href))} {...part('form')}>
              <Icon name="form" className={css.ic} part={part('icon')} />
              <span className={css.txt}>
                <b>{f.name}</b>, {f.sent}
              </span>
              <span className={account.act}>Complete</span>
            </a>
          </li>
        ))}
        {state.payments.map((p) => (
          <li key={p.href} {...part('row')}>
            <a className={css.row} href={p.href} onClick={onLink(() => actions.open(p.href))} {...part('payment')}>
              <Icon name="card" className={css.ic} part={part('icon')} />
              <span className={css.txt}>
                <b>{p.name}</b> {APPROVED_PAYMENT.after}
              </span>
              <span className={account.act}>{APPROVED_PAYMENT.action}</span>
            </a>
          </li>
        ))}
        {state.messages && (
          <li className={css.row} {...part('messages')}>
            <Icon name="msg" className={css.ic} part={part('icon')} />
            <span className={css.txt}>
              <b className={css.count}>{state.messages}</b> from {state.studioName}
            </span>
            <button type="button" className={account.act} onClick={actions.readMessages} {...part('readMessages')}>
              Read
            </button>
          </li>
        )}
      </ul>
    </section>
  );
}
